// extracted by mini-css-extract-plugin
export default {"QueryBlock":"QueryBlock_QueryBlock__U1FHx","title":"QueryBlock_title__Jn8G4","button":"QueryBlock_button__-DQVY"};